import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../config/axios';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import Logo from '../components/Logo';

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await api.get(`/auth/verify/${token}`);
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully!');
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Verification failed. The link may be expired or invalid.');
      }
    };

    if (token) {
      verify();
    }
  }, [token]);

  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md space-y-6">
        <div className="flex justify-center">
          <Logo className="h-10" showText={true} variant="dark" />
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 border border-neutral-200 text-center">
          {status === 'verifying' && (
            <>
              <div className="flex justify-center mb-4">
                <div className="spinner spinner-lg" />
              </div>
              <h2 className="text-xl font-bold text-neutral-800">Verifying your email...</h2>
              <p className="mt-2 text-neutral-500">Please wait while we confirm your email address.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                  <CheckCircleIcon className="w-8 h-8 text-green-500" />
                </div>
              </div>
              <h2 className="text-xl font-bold text-neutral-800">Email Verified!</h2>
              <p className="mt-2 text-neutral-500">{message}</p>
              <Link to="/login" className="btn-primary w-full mt-6 inline-block">
                Sign in to your account
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
                  <XCircleIcon className="w-8 h-8 text-red-500" />
                </div>
              </div>
              <h2 className="text-xl font-bold text-neutral-800">Verification Failed</h2>
              <p className="mt-2 text-neutral-500">{message}</p>
              <div className="mt-6 space-y-3">
                <Link to="/login" className="btn-primary w-full inline-block">
                  Go to Login
                </Link>
                <Link to="/register" className="btn-secondary w-full inline-block">
                  Register Again
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
